import SessionCardMobile from './session-card-mobile'

export default SessionCardMobile
